document.addEventListener('DOMContentLoaded', function () {
  // Check if Swiper is loaded
  if (typeof Swiper === 'undefined') {
    console.error('Swiper library is not loaded. Ensure swiper-bundle.min.js is included.');
    return;
  }

  // Initialize Swiper for Sliding Announcement
  const announcementBars = document.querySelectorAll('.sliding-announcement__swiper');

  if (announcementBars.length === 0) {
    console.warn('No Sliding Announcement Swiper elements found.');
    return;
  }

  announcementBars.forEach((element) => {
    const announcementSection = element.closest('.sliding-announcement');
    const autoplayEnabled = announcementSection.dataset.autoplay === 'true';
    const loop = announcementSection.dataset.loop === 'true';
    const duration = parseInt(announcementSection.dataset.swiperAutoplay) || 5000; // Default 5s
    const animationType = announcementSection.dataset.animationType || 'slide';
    const parallax = announcementSection.dataset.parallax === 'true';
    const paginationEnabled = announcementSection.dataset.pagination === 'true';

    console.log('Initializing Sliding Announcement Swiper:', {
      autoplay: autoplayEnabled,
      loop: loop,
      duration: duration,
      animationType: animationType,
      parallax: parallax,
      pagination: paginationEnabled
    });

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: loop && element.querySelectorAll('.swiper-slide').length > 1, // Only loop if multiple slides
      loopPreventsSliding: false, // Match slideshow.js
      autoplay: autoplayEnabled ? { delay: duration, disableOnInteraction: true } : false, // Match slideshow.js
      effect: animationType,
      speed: 800, // Match slideshow.js
      parallax: parallax,
      watchSlidesProgress: true, // Match slideshow.js
      preventInteractionOnTransition: true, // Match slideshow.js
      mousewheel: {
        forceToAxis: true, // Match slideshow.js
      },
      pagination: paginationEnabled ? {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      } : false,
    };

    const announcementSwiper = new Swiper(element, swiperConfig);

    // Synchronize with Slideshow
    const slideshowSwipers = document.querySelectorAll('.slideshow__swiper, .slideshow__swiper--text, .slideshow__swiper--media');
    if (slideshowSwipers.length > 0) {
      slideshowSwipers.forEach((slideshowElement) => {
        const slideshowSwiper = Swiper.getInstanceByEl(slideshowElement) || new Swiper(slideshowElement, {
          slidesPerView: 1,
          loop: loop && slideshowElement.querySelectorAll('.swiper-slide').length > 1,
          loopPreventsSliding: false,
          autoplay: autoplayEnabled ? { delay: duration, disableOnInteraction: true } : false,
          effect: animationType,
          speed: 800,
          parallax: parallax,
        });

        // Link Swiper instances for synchronized transitions
        announcementSwiper.controller.control = slideshowSwiper;
        slideshowSwiper.controller.control = announcementSwiper;

        console.log('Synchronized Swiper instances:', {
          announcementSwiper: announcementSwiper,
          slideshowSwiper: slideshowSwiper
        });
      });
    }

    // Intersection Observer to pause/resume autoplay based on visibility
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (announcementSwiper && autoplayEnabled) {
            announcementSwiper.autoplay.resume();
            console.log('Sliding Announcement Swiper resumed autoplay');
          }
        } else {
          if (announcementSwiper && autoplayEnabled) {
            announcementSwiper.autoplay.pause();
            console.log('Sliding Announcement Swiper paused autoplay');
          }
        }
      });
    }, { threshold: 0.1 });

    sectionObserver.observe(announcementSection);
  });

  // Handle dynamic section loading
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section || !section.classList.contains('section-sliding-announcement')) return;

    const element = section.querySelector('.sliding-announcement__swiper');
    if (!element) return;

    const announcementSection = element.closest('.sliding-announcement');
    const autoplayEnabled = announcementSection.dataset.autoplay === 'true';
    const loop = announcementSection.dataset.loop === 'true';
    const duration = parseInt(announcementSection.dataset.swiperAutoplay) || 5000;
    const animationType = announcementSection.dataset.animationType || 'slide';
    const parallax = announcementSection.dataset.parallax === 'true';
    const paginationEnabled = announcementSection.dataset.pagination === 'true';

    const swiperConfig = {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: loop && element.querySelectorAll('.swiper-slide').length > 1,
      loopPreventsSliding: false,
      autoplay: autoplayEnabled ? { delay: duration, disableOnInteraction: true } : false,
      effect: animationType,
      speed: 800,
      parallax: parallax,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      pagination: paginationEnabled ? {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      } : false,
    };

    const announcementSwiper = new Swiper(element, swiperConfig);

    const slideshowSwipers = document.querySelectorAll('.slideshow__swiper, .slideshow__swiper--text, .slideshow__swiper--media');
    if (slideshowSwipers.length > 0) {
      slideshowSwipers.forEach((slideshowElement) => {
        const slideshowSwiper = Swiper.getInstanceByEl(slideshowElement) || new Swiper(slideshowElement, {
          slidesPerView: 1,
          loop: loop && slideshowElement.querySelectorAll('.swiper-slide').length > 1,
          loopPreventsSliding: false,
          autoplay: autoplayEnabled ? { delay: duration, disableOnInteraction: true } : false,
          effect: animationType,
          speed: 800,
          parallax: parallax,
        });

        announcementSwiper.controller.control = slideshowSwiper;
        slideshowSwiper.controller.control = announcementSwiper;
      });
    }

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (announcementSwiper && autoplayEnabled) {
            announcementSwiper.autoplay.resume();
          }
        } else {
          if (announcementSwiper && autoplayEnabled) {
            announcementSwiper.autoplay.pause();
          }
        }
      });
    }, { threshold: 0.1 });

    sectionObserver.observe(announcementSection);
  });
});